import React from 'react';

interface HideConfirmationDialogProps {
  request: any;
  onConfirm: () => void;
  onCancel: () => void;
  isHidden: boolean;
}

export function HideConfirmationDialog({
  request,
  onConfirm,
  onCancel,
  isHidden,
}: HideConfirmationDialogProps) {
  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white rounded-lg p-6 max-w-md w-full">
        <h3 className="text-lg font-medium text-gray-900 mb-4">
          {isHidden ? "Unhide Request" : "Hide Request"}
        </h3>
        <p className="text-gray-600 mb-6">
          Are you sure you want to {isHidden ? "unhide" : "hide"} this request for {request?.car_make} {request?.car_model}? 
          {isHidden ? " It will be visible in your main request list." : " You can unhide it later from the hidden requests view."}
        </p>
        <div className="flex justify-end space-x-4">
          <button onClick={onCancel} className="px-4 py-2 text-gray-600 hover:text-gray-900">
            Cancel
          </button>
          <button onClick={onConfirm} className="px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700">
            {isHidden ? "Unhide Request" : "Hide Request"}
          </button>
        </div>
      </div>
    </div>
  );
}